import React, { Component } from "react";
import {
  View,
  ScrollView,
  Platform,
  TouchableOpacity,
  Text,
} from "react-native";
import {
  Flex,
  Margin,
  Helpers,
  appStyles,
  FontFamily,
  button,
} from "../../styles/appStyles";

import Button from "../../components/button";
import ButtonGradient from "../../components/button-gradient";
import CustomImage from "../../components/custom-image";
import { helpers } from "../../utils/helpers";
import apiHelpers from "../../utils/api-helpers";
import AppHeader from "../../components/app-header";
import AppFooter from "../../components/app-footer";
import HomeFromArchives from "../../components/home-from-archives";
import ContentLoader from "react-native-easy-content-loader";
import HomeCover from "../../components/home-cover";
import HomeLatestStory from "../../components/home-latest-story";
import HomeFeaturedStory from "../../components/home-featured-story";
import HomeStoriesForYou from "../../components/home-stories-for-you";
import HomePopularCategories from "../../components/home-popular-categories";
import HomeTrendingStories from "../../components/home-trending-stories";
import HomeReadingList from "../../components/home-reading-list";
import ErrorModal from "../../components/error-modal";
import HomePremiumStory from "../../components/home-premium-stories";
import HomeStarterCollection from "../../components/home-starter-collection";
import HomeNewsLetters from "../../components/home-news-letters";
import HomeExclusiveContent from "../../components/home-exclusive-content";
import HomeArchievedContent from "../../components/home-archived-content";
import HomeReadersQuote from "../../components/home-readers-quote";
import HomeChooseSubscription from "../../components/home-choose-subscription";
import HomeOurMission from "../../components/home-our-mission";
import HomeBanner from "../../components/home-banner";
import HomeWhyTMCSection from "../../components/why-choose-tmc";
import AppAvailablePoster from "../../components/available-on-mobile";
import HomeShortReads from "../../components/short-reads";
import HomeFreeTrial from "../../components/free-trial";
import TmcDialogue from "../../components/tmc-dialogue";
import DarkModeSwitch from "../../components/darkmode-switch";
import Cookies from "universal-cookie";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { removeUserToken } from "../../../redux/User/user.actions";
import { storeFcmToken } from "../../../redux/App/app.actions";
import { Mixpanel } from "../../utils/mixpanel";
import Seo from "../../components/seo-meta";
import NavigationBarColor from "../../components/navigation-bar-color";
import seoObj from "../../utils/seo-helper";
import JoinYoutube from "../../components/joinYoutube";
import ExclusiveSlider from "../../components/home-exclusive-content/ExclusiveSlider";

import getImagePath from "../../utils/image-helper";
import AuthenticationWrapper from "../../components/authentication-wrapper";
import { HomeNewsletterSection } from "../../components/home-newsletter-section";
import { HomeNewsletterCategories } from "../../components/home-newsletter-categories";
import PremiumSlider from "../../components/home-news-letters/PremiumSlider";
import WritersSlider from "../../components/home-news-letters/WritersSlider";
import CreditExpiryBand from "../../components/credit-expiry-band";
import PaidExpiryBand from "../../components/credit-expiry-band/index-paid";
import HomeRecentNewsletters from "../../components/home-recent-newsletters";
import { HomeYesterdayStory } from "../../components/home-yesterday-story";
import GeneralNotificationBand from "../../components/general-notification-band";
import {
  renderBorderColor,
  categoryImage,
  paddingCategory,
} from "../../screens/yesterday/renderBorderColor";
import truncate from "truncate-html";
import PostContent from "../../components/post-content";
import moment from "moment";
import { ChargebeeController } from "../../utils/chargebee";

const YesterdayLogo1 = getImagePath("img/YesterdayLogo1.png");
const bg2 = getImagePath("img/bg2.png");
const yesterdayLogo = getImagePath("icons/yesterdayLogo.png");
const healthcare = getImagePath("icons/healthcare.png");
const rightArrow = getImagePath("icons/rightArrow.png");

const cookies = new Cookies();

export class Home extends Component {
  constructor(props) {
    super(props);
    let webView = helpers.isWeb();
    const { isAuthenticated, fetchToken } = this.props.auth;
    let token = webView
      ? process.browser
        ? isAuthenticated
          ? fetchToken
          : false
        : this.props.token
      : this.props.user?.userData?.data?.token;
    this.state = {
      unpaidInvoiceLoader: false,
      canShowBandLoader: false,
      whatsTrendingContent:
        this.props.homeData && this.props.homeData.whatsTrendingContent
          ? this.props.homeData.whatsTrendingContent
          : false,
      latestStories:
        this.props.homeData && this.props.homeData.latestStories
          ? this.props.homeData.latestStories
          : false,
      featuredStory:
        this.props.homeData && this.props.homeData.featuredStory
          ? this.props.homeData.featuredStory
          : false,
      premiumStories:
        this.props.homeData && this.props.homeData.premiumStories
          ? this.props.homeData.premiumStories
          : false,
      userStarterCollection:
        this.props.homeData && this.props.homeData.userStarterCollection
          ? this.props.homeData.userStarterCollection
          : false,
      storiesForYou: false,
      readingList: false,
      subscriptionDetails: {},
      expiredSubscription: {},
      latestPremiumStories: [],
      trendingStoriesContent:
        this.props.homeData && this.props.homeData.trendingStoriesContent
          ? this.props.homeData.trendingStoriesContent
          : false,
      pageLoader: this.props.homeData ? false : true,
      footerData: this.props.footerData ? this.props.footerData : false,
      showErrorModal: false,
      token: token == undefined || token == "" ? false : token,
      userLoggedin: token == undefined || token == "" ? false : true,
      homeContent:
        this.props.homeData && this.props.homeData.homeContent
          ? this.props.homeData.homeContent
          : false,
      exclusiveContent:
        this.props.homeData && this.props.homeData.exclusiveContent
          ? this.props.homeData.exclusiveContent
          : false,
      archivedStories: false,
      subscriptionRefreshKey: false,
      userHasSubscription:
        this.props.homeData && this.props.homeData.userHasSubscription
          ? this.props.homeData.userHasSubscription
          : false,
      writers: false,
      storyData: [],
      userPaymentInfo: null
    };
  }

  componentDidMount = () => {
    this.getData();
    let { token } = this.state;
    if (!helpers.isWeb() && token) {
      if (Platform.OS == "ios") {
        setTimeout(() => {
          this.sendDeviceToken();
        }, 10000);
      } else {
        this.sendDeviceToken();
      }
    }
  };

  getData = async () => {
    if (this.state.token) {
      if (!this.state.homeContent) {
        this.getHomeContent(["newsletters"]);
      }
      if (this.state.latestPremiumStories.length === 0) {
        this.getPremiumStories();
      }
      if (!this.state.whatsTrendingContent) {
        this.getTrending();
      } else if (!this.state.latestStories) {
        this.getHomeData(this.state.whatsTrendingContent);
      } else if (
        !this.state.premiumStories &&
        !this.state.userHasSubscription
      ) {
        this.getUserStories();
      } else if (!this.state.trendingStoriesContent) {
        this.getTrendingStories();
      }

      // if (this.state.trendingStoriesContent && !this.state.readingList) {
      //     this.getUserReadingList()
      // }
      if (!this.state.exclusiveContent) {
        this.getExclusiveContent();
      }
    } else {
      if (!this.state.homeContent) {
        this.getHomeContent(["newsletters", "readers_quotes"]);
      }

      await this.getWriters();
      this.setState({ userInfoFetched: true, trendingStoriesContent: true });
      this.getEditions();

      if (!this.state.exclusiveContent) {
        this.getExclusiveContent();
      } else if (!this.state.archivedStories) {
        this.getArchivedStories(this.state.exclusiveContent);
      }
    }
  };

  getEditions = () => {
    let endpoint = `/yesterday/editions`;
    let body = {};
    body = {
      sort_on: "DESC",
      sort_by: "published_date",
      // "published_date": moment(new Date()).format("DD-MM-YYYY"),
      start_date: moment(new Date()).subtract(30, "days").format("DD-MM-YYYY"),
      end_date: moment(new Date()).format("DD-MM-YYYY"),
      limit: 1,
      truncate: 1,
      count: 200,
    };
    apiHelpers
      .apiRequest(endpoint, body, "POST", true, null)
      .then((res) => {
        this.setState({
          storyData: res.data.editions[0],
        });
      })
      .catch((error) => {
        this.setState({
          storyDataLastWeek: error.ok,
        });
        console.log("Error=>> down", JSON.stringify(error));
      });
  };

  componentDidUpdate = (prevProps) => {
    let webView = helpers.isWeb();
    let token = webView
      ? this.props.auth.fetchToken
      : this.props.user?.userData?.data?.token;
    if (
      (token && token != this.state.token) ||
      ((token == undefined || token == "") && this.state.token != false) ||
      (!helpers.isWeb() &&
        prevProps.app.refreshScreen != this.props.app.refreshScreen &&
        !this.props.navigation.isFocused())
    ) {
      let tokenSet = token == undefined || token == "" ? false : true;
      this.setState(
        {
          token: tokenSet ? token : false,
          userLoggedin: tokenSet,
          pageLoader: true,
          whatsTrendingContent: false,
          latestStories: false,
          featuredStory: false,
          premiumStories: false,
          userStarterCollection: false,
          storiesForYou: false,
          trendingLoader: true,
          freeUser: false,
          userInfoFetched: false,
          readingList: false,
          trendingStoriesContent: false,
          showErrorModal: false,
          homeContent: false,
          exclusiveContent: false,
          archivedStories: false,
          subscriptionRefreshKey: false,
          userHasSubscription: false,
        },
        () => {
          this.getData();
        }
      );
    }
  };

  getExclusiveContent = () => {
    this.setState({ showErrorModal: false, pageLoader: true });
    let endpoint = `/stories`;
    let body = {
      limit: 1,
      filters: [
        { key: "is_featured", value: true },
        { key: "single_category", value: true },
      ],
    };
    apiHelpers
      .apiRequest(endpoint, body, "POST", true, false)
      .then((res) => {
        if (res.success && res.code == "story_found") {
          this.setState({
            exclusiveContent: res.data.story,
            pageLoader: false,
            archive_days: 0,
          });
          this.getArchivedStories(res.data.story);
        } else {
          this.setState({
            showErrorModal: true,
            pageLoader: false,
          });
          console.log("Error=>>", JSON.stringify(res));
        }
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          showErrorModal: true,
          pageLoader: false,
        });
        console.log("Error=>> down", JSON.stringify(error));
      });
  };

  getArchivedStories = (excludeData = []) => {
    this.setState({
      showErrorModal: false,
    });
    let excludeList = excludeData.map((td) => {
      return td.id;
    });
    // const { token, whatsTrendingContent, latestStories, featuredStory, premiumStories, userStarterCollection } = this.state;
    // let excludeList = [];
    // if (latestStories) {
    //     excludeList = latestStories.map((ls) => {
    //         return ls.id;
    //     })
    // }
    // if (featuredStory) {
    //     excludeList.push(featuredStory.id);
    // }
    // if (whatsTrendingContent) {
    //     excludeList.push(whatsTrendingContent.id);
    // }

    let endpoint = `/stories`;
    let body = {
      limit: 1,
      exclude: excludeList,
      sort_on: "date",
      sort_by: "desc",
      // filters: [{ key: "single_category", value: true }]
      filters: [
        { key: "is_privileged", value: false },
        { key: "single_category", value: true },
      ],
    };
    apiHelpers
      .apiRequest(endpoint, body, "POST", true, false)
      .then((res) => {
        if (res.success && res.code == "story_found") {
          this.setState({
            archivedStories: res.data.story,
            pageLoader: false,
          });
        } else {
          console.log("Error=>>", JSON.stringify(res));
        }
      })
      .catch((error) => {
        console.log(error);
        console.log("Error=>> down", JSON.stringify(error));
      });
  };

  getPremiumStories = () => {
    this.setState({
      showErrorModal: false,
    });
    let endpoint = `/stories`;
    let body = {
      limit: 10,
      filters: [
        { key: "newsletter", value: ["include"] },
        { key: "", value: ["include"] },
      ],
    };
    apiHelpers
      .apiRequest(endpoint, body, "POST", true, this.state.token)
      .then((res) => {
        if (res.success && res.code == "story_found") {
          this.setState({
            latestPremiumStories: res.data.story,
          });
          // w, () => this.getTrendingStories());
        } else {
          console.log("Error=>>", JSON.stringify(res));
        }
      })
      .catch((error) => {
        console.log(error);
        console.log("Error=>> down", JSON.stringify(error));
      });
  };

  getHomeContent = (content) => {
    const { token } = this.state;
    let endpoint = `/static-content`;
    let body = {
      content: content,
    };
    apiHelpers
      .apiRequest(endpoint, body, "POST", true, false)
      .then((res) => {
        if (res.success && res.code == "content_found") {
          this.setState({ homeContent: res.data });
        } else {
          console.log("Error=>>", JSON.stringify(res));
        }
      })
      .catch((error) => {
        console.log(error);
        console.log("Error=>> down", JSON.stringify(error));
      });
  };

  getTrending = () => {
    this.setState({
      showErrorModal: false,
      pageLoader: true,
    });
    const { token } = this.state;
    let endpoint = `/stories`;
    let body = {
      limit: 1,
    };
    apiHelpers
      .apiRequest(endpoint, body, "POST", true, false)
      .then((res) => {
        if (res.success && res.code == "story_found") {
          let trendingData = res.data.story;
          this.setState({
            whatsTrendingContent: trendingData[0],
            pageLoader: false,
          });
          this.getHomeData(trendingData[0]);
        } else {
          this.setState({
            showErrorModal: true,
            pageLoader: false,
          });
          console.log("Error=>>", JSON.stringify(res));
        }
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          showErrorModal: true,
          pageLoader: false,
        });
        console.log("Error=>> down", JSON.stringify(error));
      });
  };

  getHomeData = (whatsTrending) => {
    const { token } = this.state;
    let endpoint = `/stories`;
    let body = {
      limit: 2,
      exclude: [whatsTrending.id],
      filters: [
        {
          key: "single_category",
          value: true,
        },
      ],
    };
    apiHelpers
      .apiRequest(endpoint, body, "POST", true, false)
      .then((res) => {
        if (res.success && res.code == "story_found") {
          let trendingData = res.data.story;
          this.setState({
            latestStories: trendingData,
          });
          this.getFeaturedStories(res.data.story, whatsTrending);
        } else {
          console.log("Error=>>", JSON.stringify(res));
        }
      })
      .catch((error) => {
        console.log(error);
        console.log("Error=>> down", JSON.stringify(error));
      });
  };

  getFeaturedStories = (trendingData, whatsTrending) => {
    this.setState({
      showErrorModal: false,
    });
    let excludeList = trendingData.map((td) => {
      return td.id;
    });
    excludeList.push(whatsTrending.id);
    const { token } = this.state;
    let endpoint = `/stories/popular`;
    let body = {
      archive_days: 0,
      limit: 10,
      exclude: excludeList,
      days_before: 30,
    };
    apiHelpers
      .apiRequest(endpoint, body, "POST", true, token)
      .then((res) => {
        if (res.success && res.code == "story_found") {
          let latestStoriesData = res.data.story;
          this.setState(
            {
              featuredStory: latestStoriesData,
              pageLoader: false,
            },
            () => this.getUserStories(),
            this.getArchivedStories()
          );
        } else {
          console.log("Error=>>", JSON.stringify(res));
          this.getUserStories();
        }
      })
      .catch((error) => {
        console.log(error);
        console.log("Error=>> down", JSON.stringify(error));
      });
  };

  getUserStories = () => {
    this.getUserInfo().then((response) => {
      let subscription = response.subscription;
      if (
        subscription &&
        Object.keys(subscription).length != 0 &&
        subscription.status == "active"
      ) {
        this.getTrendingStories();
      } else {
        const {
          token,
          whatsTrendingContent,
          latestStories,
          featuredStory,
          premiumStories,
          userStarterCollection,
        } = this.state;
        let excludeList = [];
        if (latestStories) {
          excludeList = latestStories.map((ls) => {
            return ls.id;
          });
        }
        if (featuredStory) {
          excludeList.push(featuredStory.id);
        }
        if (whatsTrendingContent) {
          excludeList.push(whatsTrendingContent.id);
        }

        let endpoint = `/users-stories`;
        let body = {
          limit: 1,
          exclude: excludeList,
          sort_on: "date",
          sort_by: "desc",
          filters: [
            { key: "single_category", value: true },
            { key: "", value: ["include"] },
          ],
        };
        apiHelpers
          .apiRequest(endpoint, body, "POST", true, token)
          .then((res) => {
            if (res.success && res.code == "story_found") {
              this.setState(
                {
                  premiumStories: res.data.privileged.story,
                  userStarterCollection: res.data.non_privileged.story,
                },
                () => this.getTrendingStories()
              );
            } else {
              console.log("Error=>>", JSON.stringify(res));
            }
          })
          .catch((error) => {
            console.log(error);
            console.log("Error=>> down", JSON.stringify(error));
          });
      }
    });
  };

  isObjectEmpty(obj) {
    for (var prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        return false;
      }
    }
    return JSON.stringify(obj) === JSON.stringify({});
  }

  getUserInfo = () => {
    return new Promise((resolve, reject) => {
      const { token } = this.state;
      if (!token) {
        this.setState({ userInfoFetched: true });
        resolve(false);
      } else {
        let endpoint = `/profile`;
        let body = {
          request_group: ["subscription"],
        };
        apiHelpers
          .apiRequest(endpoint, body, "POST", true, token)
          .then((res) => {
            if (res.success) {
              this.setState({
                freeUser:
                  (res.data.team_subscription &&
                    !this.isObjectEmpty(res.data.team_subscription)) ||
                    (res.data.subscription &&
                      !this.isObjectEmpty(res.data.subscription))
                    ? false
                    : true,
                userInfoFetched: true,
                subscriptionDetails:
                  res.data.team_subscription &&
                    res.data.team_subscription.is_team_owner
                    ? res.data.team_subscription
                    : res.data.subscription,
                expiredSubscription: res.data.expired_subscription,
              });
              this.advanceRenewalChecks()
              resolve(res.data);
            } else {
              this.setState({ userInfoFetched: true });
              resolve(false);
            }
          })
          .catch((error) => {
            console.log("Error=>>", error);
            this.setState({ userInfoFetched: true });
            resolve(false);
          });
      }
    });
  };

  getTrendingStories() {
    this.setState({
      showErrorModal: false,
      pageLoader: true,
    });
    const {
      token,
      whatsTrendingContent,
      latestStories,
      featuredStory,
      premiumStories,
      userStarterCollection,
    } = this.state;
    let excludeList = [];
    if (latestStories) {
      excludeList = latestStories.map((ls) => {
        return ls.id;
      });
    }
    if (featuredStory) {
      excludeList.push(featuredStory.id);
    }
    if (whatsTrendingContent) {
      excludeList.push(whatsTrendingContent.id);
    }

    if (premiumStories) {
      premiumStories.map((fas) => {
        excludeList.push(fas.id);
      });
    }

    if (userStarterCollection) {
      userStarterCollection.map((fas) => {
        excludeList.push(fas.id);
      });
    }

    let endpoint = `/stories/popular`;
    let body = {
      limit: 3,
      exclude: excludeList,
      filters: [{ key: "single_category", value: true }],
    };
    apiHelpers
      .apiRequest(endpoint, body, "POST", true, token)
      .then((res) => {
        if (res.success && res.code == "story_found") {
          this.setState(
            {
              trendingStoriesContent: res.data.story,
            },
            () => {
              this.setState({ pageLoader: false, trendingLoader: false });
            }
          );
          // if (!this.state.readingList) {
          //     this.getUserReadingList()
          // }
        } else {
          this.setState({
            pageLoader: false,
            trendingLoader: false,
          });
          console.log("Error=>>", JSON.stringify(res));
        }
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          pageLoader: false,
          trendingLoader: false,
        });
        console.log("Error=>> down", JSON.stringify(error));
      });
  }

  // getUserReadingList = () => {
  //     this.setState({
  //         showErrorModal: false,
  //     });
  //     const { token } = this.state;
  //     let endpoint = `/user-action-story-list`;
  //     let body = {
  //         "type": "bookmark",
  //         "limit": 2,
  //         "page": 1
  //     }
  //     apiHelpers
  //         .apiRequest(endpoint, body, "POST", true, token)
  //         .then((res) => {
  //             if (res.success && res.code == 'story_found') {
  //                 this.setState({
  //                     readingList: res.data.story,
  //                 });
  //             } else {
  //                 console.log('Error=>>', JSON.stringify(res));
  //             }
  //         })
  //         .catch((error) => {
  //             console.log('Error=>> down', JSON.stringify(error));
  //         });
  // }
  segregateWriters = (writerList) => {
    let writers = [],
      contributors = [];
    writerList.map((writer) => {
      if (writer.roles.includes("contributor")) {
        contributors.push(writer);
      } else {
        writers.push(writer);
      }
    });
    return { writers: writers, contributors: contributors };
  };
  getWriters = () => {
    this.setState({
      showErrorModal: false,
      pageLoader: true,
    });
    const { token } = this.state;
    let endpoint = `/authors`;
    let body = {
      sort_on: "name",
      sort_by: "asc",
      filters: [{ key: "roles", value: ["editor"] }],
    };
    apiHelpers
      .apiRequest(endpoint, body, "POST", true)
      .then((res) => {
        if (res.success && res.code == "author_found") {
          // let writerData = this.sortWriter(res.data.author);
          let allWriters = this.segregateWriters(res.data.author);
          this.setState({
            // writers: allWriters['writers'],
            writers: allWriters.writers,
            contributorData: allWriters["contributors"],
            pageLoader: false,
          });
        } else {
          this.setState({
            showErrorModal: true,
            pageLoader: false,
          });
          console.log("Error=>>", JSON.stringify(res));
        }
      })
      .catch((error) => {
        this.setState({
          showErrorModal: true,
          pageLoader: false,
        });
        console.log("Error=>> down", JSON.stringify(error));
      });
  };

  viewArticle = (catSlug, slug, postData) => {
    if (helpers.isWeb()) {
      this.props.navigateToScreen("/" + catSlug + "/" + slug);
    } else {
      this.props.navigation.navigate("post-single", {
        categorySlug: catSlug,
        postSlug: slug,
        postData: postData,
      });
    }
  };

  viewAllArticles = () => {
    let categorySlug = "business";
    if (helpers.isWeb()) {
      this.props.navigateToScreen("/category/" + categorySlug + "/all");
    } else {
      this.props.navigation.navigate("category-archive", {
        archiveSlug: categorySlug,
      });
    }
  };

  viewMoreArticles = () => {
    if (helpers.isWeb()) {
      this.props.navigateToScreen("/all-stories");
    } else {
      this.props.navigation.navigate("/all-stories", { categorySlug: "all" });
    }
  };

  viewAuthor = (slug) => {
    if (helpers.isWeb()) {
      this.props.navigateToScreen("/writers/" + slug);
    } else {
      this.props.navigation.navigate("writer-single", { writerSlug: slug });
    }
  };

  viewCompany = (slug) => {
    if (helpers.isWeb()) {
      this.props.navigateToScreen("/company/" + slug);
    } else {
      this.props.navigation.navigate("company", { companySlug: slug });
    }
  };

  viewCategory = (slug) => {
    if (helpers.isWeb()) {
      this.props.navigateToScreen("/category/" + slug);
    } else {
      this.props.navigation.navigate("category", { categorySlug: slug });
    }
  };

  navigateToNewsletter = (slug) => {
    if (helpers.isWeb()) {
      this.props.navigateToScreen("/newsletters/" + slug);
    } else {
      this.props.navigation.navigate("single-newsletter", {
        newsletterSlug: slug,
      });
    }
  };

  navigateToTag = (slug) => {
    if (helpers.isWeb()) {
      this.props.navigateToScreen("/tags/" + slug);
    } else {
      this.props.navigation.navigate("tags-archive", { archiveSlug: slug });
    }
  };

  viewAllStories = () => {
    if (helpers.isWeb()) {
      // this.props.navigateToScreen('/newsletters/' + slug);
    } else {
      this.props.navigation.navigate("/all-stories", { archiveSlug: "all" });
    }
  };

  viewStarterCollection = () => {
    if (helpers.isWeb()) {
      // this.props.navigateToScreen('/newsletters/' + slug);
    } else {
      this.props.navigation.navigate("/starter-collection", {
        collectionType: "starter",
      });
    }
  };

  renderPageHeader = () => {
    return <View style={[Margin.mt_4]}></View>;
  };

  sendDeviceToken = () => {
    let { fcmToken } = this.props.app;
    let { token } = this.state;
    helpers
      .getNotificationToken()
      .then((fcm_token) => {
        console.log("check token ==>", fcm_token);
        if (fcm_token !== fcmToken) {
          let endpoint = `/edit-profile`;
          let body = {
            fcm_token: fcm_token,
            fcm_token_action: "add",
          };
          apiHelpers
            .apiRequest(endpoint, body, "POST", true, token)
            .then((res) => {
              if (res.success) {
                this.props.storeFcmToken(fcm_token);
              }
            })
            .catch((error) => {
              console.log("store device token notification error=>", error);
              if (error.status == 401) {
              }
            });
        }
      })
      .catch((error) => {
        console.log("erron in getting tokne", error);
      });
  };

  renderPageContent = () => {
    let {
      whatsTrendingContent,
      latestPremiumStories,
      subscriptionDetails,
      credits,
      token,
      freeUser,
      userInfoFetched,
      readingList,
      userHasSubscription,
      trendingStoriesContent,
      premiumStories,
      storiesForYou,
      featuredStory,
      userStarterCollection,
      homeContent,
      exclusiveContent,
      archivedStories,
      expiredSubscription,
    } = this.state;

    let darkMode = helpers.isDarkMode(this.props?.app?.DarkMode);
    return (
      <>
        {token ? (
          <>
            {userInfoFetched &&
              freeUser &&
              !expiredSubscription &&
              credits?.non_privileged_credits?.available === 0 &&
              this.renderCreditExpiryBand()}

            {userInfoFetched &&
              !freeUser &&
              subscriptionDetails &&
              this.isSubscriptionUnderDunning() &&
              this.renderUnpaidInvoiceBand()}
            {userInfoFetched &&
              freeUser &&
              expiredSubscription &&
              this.renderSubscriptionExpiryBand()}
            {freeUser &&
              userStarterCollection &&
              this.renderuserStarterCollection()}

            {/* {this.renderSubscriptionRenewalBand()} */}
            { !this.isSubscriptionUnderDunning() && this.paymentBandChain() }

            {/* {userInfoFetched && !freeUser && whatsTrendingContent && this.renderHomeCover()} */}

            {userInfoFetched &&
              latestPremiumStories &&
              !freeUser &&
              this.renderLatestStory()}

            {helpers.isWeb() && this.renderDarkModeSwitch()}

            {trendingStoriesContent && this.renderHomeTrendingStories()}

            {this.renderPopularCategory()}

            {featuredStory && userHasSubscription && this.renderFeaturedStory()}

            {premiumStories &&
              userHasSubscription &&
              this.renderPremiumStories()}

            <View style={helpers.isDesktop() && { height: 700 }}>
              {homeContent && homeContent.newsletters && this.renderCarousal()}

              {/* {this.renderCarousal()} */}
            </View>

            {/* {homeContent && this.renderuserNewsletterCollection()} */}

            {!freeUser && this.renderRecentNewsletters()}
            {this.renderNewsletterCategory("token")}

            {freeUser && (
              <View
                style={
                  helpers.isDesktop()
                    ? { height: 950 }
                    : !helpers.isWeb()
                      ? { height: 500 }
                      : null
                }
              >
                {exclusiveContent && this.renderExlusiveContent()}
              </View>
            )}

            {freeUser && this.renderSubscriptionSection()}

            {this.renderJoinYoutube()}
          </>
        ) : (
          <>
            {this.renderHomeBannerSection()}

            {this.renderOurMissionSection()}

            {this.renderWhyTMCSection()}

            {this.renderArchivedStories()}
            {this.renderYesterdaySection()}
            <View style={helpers.isDesktop() && { height: 700 }}>
              {homeContent && homeContent.newsletters && this.renderCarousal()}

              {/* {this.renderCarousal()} */}
            </View>
            {this.renderNewsletterCategory("no-token")}

            <View
              style={{ height: helpers.isWeb() ? 500 : 500, marginTop: 10 }}
            >
              {this.state.writers && this.renderWriters()}
            </View>

            {homeContent &&
              homeContent.readers_quotes &&
              this.renderReadersQuotes()}

            <View style={helpers.isDesktop() ? { height: 950 } : !helpers.isWeb() ? { height: 500 } : null}>
              {exclusiveContent && this.renderExlusiveContent()}
            </View>

            {/* {this.renderFreeTrialSection()} */}

            {/* <TmcDialogue darkMode={darkMode} /> */}

            {this.renderSubscriptionSection()}

            {/* {helpers.isWeb() &&
                            this.renderAppAvailablePosterSection()
                        } */}

            {this.renderJoinYoutube()}
          </>
        )}
      </>
    );
  };

  showPageLoader = () => {
    const webView = helpers.isWeb();
    let darkMode = helpers.isDarkMode(this.props?.app?.DarkMode);
    return (
      <View
        style={[
          Helpers.conatinerWeb,
          helpers.isDesktop() && Helpers.conatinerWebFull,
          helpers.isDesktop() && { marginBottom: 100 },
        ]}
      >
        <ContentLoader
          containerStyles={{
            paddingHorizontal: 0,
            marginTop: 0,
            marginBottom: 0,
          }}
          active={true}
          pHeight={[50]}
          title={false}
          pRows={1}
          pWidth={["100%"]}
          paragraphStyles={{ marginBottom: 20, marginTop: 40 }}
          animationDuration={400}
          primaryColor={
            darkMode ? "rgba(45, 48, 45,1)" : "rgba(220, 220, 220, 1)"
          }
          secondaryColor={
            darkMode ? "rgba(45, 48, 45,0.8)" : "rgba(200, 200, 200, 1)"
          }
        />
        <ContentLoader
          containerStyles={{
            paddingHorizontal: 0,
            marginTop: 0,
            marginBottom: 0,
          }}
          active={true}
          pHeight={[400]}
          title={false}
          pRows={5}
          pWidth={["100%"]}
          paragraphStyles={{ marginBottom: 60, marginTop: 0 }}
          animationDuration={400}
          primaryColor={
            darkMode ? "rgba(45, 48, 45,1)" : "rgba(220, 220, 220, 1)"
          }
          secondaryColor={
            darkMode ? "rgba(45, 48, 45,0.8)" : "rgba(200, 200, 200, 1)"
          }
        />
        <ContentLoader
          containerStyles={{
            paddingHorizontal: 0,
            marginTop: 0,
            marginBottom: 0,
          }}
          active={true}
          pHeight={[50]}
          title={false}
          pRows={1}
          pWidth={["100%"]}
          paragraphStyles={{ marginBottom: 20, marginTop: 40 }}
          animationDuration={400}
          primaryColor={
            darkMode ? "rgba(45, 48, 45,1)" : "rgba(220, 220, 220, 1)"
          }
          secondaryColor={
            darkMode ? "rgba(45, 48, 45,0.8)" : "rgba(200, 200, 200, 1)"
          }
        />
        <ContentLoader
          containerStyles={{
            paddingHorizontal: 0,
            marginTop: 0,
            marginBottom: 0,
          }}
          active={true}
          pHeight={[70]}
          title={false}
          pRows={3}
          pWidth={["100%"]}
          paragraphStyles={{ marginBottom: 20, marginTop: 40 }}
          animationDuration={400}
          primaryColor={
            darkMode ? "rgba(45, 48, 45,1)" : "rgba(220, 220, 220, 1)"
          }
          secondaryColor={
            darkMode ? "rgba(45, 48, 45,0.8)" : "rgba(200, 200, 200, 1)"
          }
        />
        <View>
          <ContentLoader
            containerStyles={{
              paddingHorizontal: 0,
              marginTop: 0,
              marginBottom: 40,
            }}
            active={true}
            pHeight={[80]}
            title={false}
            pRows={1}
            pWidth={["100%"]}
            paragraphStyles={{ marginBottom: 40, marginTop: 0 }}
            animationDuration={400}
            primaryColor={
              darkMode ? "rgba(45, 48, 45,1)" : "rgba(220, 220, 220, 1)"
            }
            secondaryColor={
              darkMode ? "rgba(45, 48, 45,0.8)" : "rgba(200, 200, 200, 1)"
            }
          />
        </View>
        <View style={[Flex.row]}>
          <View style={{ flex: 0.4 }}>
            <ContentLoader
              containerStyles={{
                paddingHorizontal: 0,
                marginTop: 0,
                marginBottom: 0,
              }}
              active={true}
              pHeight={[200]}
              title={false}
              pRows={1}
              pWidth={["100%"]}
              paragraphStyles={{ marginBottom: 40, marginTop: 0 }}
              animationDuration={400}
              primaryColor={
                darkMode ? "rgba(45, 48, 45,1)" : "rgba(220, 220, 220, 1)"
              }
              secondaryColor={
                darkMode ? "rgba(45, 48, 45,0.8)" : "rgba(200, 200, 200, 1)"
              }
            />
          </View>
          <View style={[Margin.ml_2, { flex: 0.6 }]}>
            <ContentLoader
              containerStyles={{
                paddingHorizontal: 0,
                marginTop: 0,
                marginBottom: 0,
              }}
              active={true}
              pHeight={[50]}
              title={false}
              pRows={1}
              pWidth={["100%"]}
              paragraphStyles={{ marginBottom: 40, marginTop: 0 }}
              animationDuration={400}
              primaryColor={
                darkMode ? "rgba(45, 48, 45,1)" : "rgba(220, 220, 220, 1)"
              }
              secondaryColor={
                darkMode ? "rgba(45, 48, 45,0.8)" : "rgba(200, 200, 200, 1)"
              }
            />
            <ContentLoader
              containerStyles={{
                paddingHorizontal: 0,
                marginTop: 0,
                marginBottom: 0,
              }}
              active={true}
              pHeight={[20]}
              title={false}
              pRows={2}
              pWidth={["100%"]}
              paragraphStyles={{ marginBottom: 20, marginTop: 0 }}
              animationDuration={400}
              primaryColor={
                darkMode ? "rgba(45, 48, 45,1)" : "rgba(220, 220, 220, 1)"
              }
              secondaryColor={
                darkMode ? "rgba(45, 48, 45,0.8)" : "rgba(200, 200, 200, 1)"
              }
            />
            <ContentLoader
              containerStyles={{
                paddingHorizontal: 0,
                marginTop: 0,
                marginBottom: 0,
              }}
              active={true}
              pHeight={[30]}
              title={false}
              pRows={2}
              pWidth={["100%"]}
              paragraphStyles={{ marginBottom: 0, marginTop: 0 }}
              animationDuration={400}
              primaryColor={
                darkMode ? "rgba(45, 48, 45,1)" : "rgba(220, 220, 220, 1)"
              }
              secondaryColor={
                darkMode ? "rgba(45, 48, 45,0.8)" : "rgba(200, 200, 200, 1)"
              }
            />
          </View>
        </View>
        <View style={[Flex.row]}>
          <View style={{ flex: 0.4 }}>
            <ContentLoader
              containerStyles={{
                paddingHorizontal: 0,
                marginTop: 0,
                marginBottom: 0,
              }}
              active={true}
              pHeight={[200]}
              title={false}
              pRows={1}
              pWidth={["100%"]}
              paragraphStyles={{ marginBottom: 40, marginTop: 0 }}
              animationDuration={400}
              primaryColor={
                darkMode ? "rgba(45, 48, 45,1)" : "rgba(220, 220, 220, 1)"
              }
              secondaryColor={
                darkMode ? "rgba(45, 48, 45,0.8)" : "rgba(200, 200, 200, 1)"
              }
            />
          </View>
          <View style={[Margin.ml_2, { flex: 0.6 }]}>
            <ContentLoader
              containerStyles={{
                paddingHorizontal: 0,
                marginTop: 0,
                marginBottom: 0,
              }}
              active={true}
              pHeight={[50]}
              title={false}
              pRows={1}
              pWidth={["100%"]}
              paragraphStyles={{ marginBottom: 20, marginTop: 0 }}
              animationDuration={400}
              primaryColor={
                darkMode ? "rgba(45, 48, 45,1)" : "rgba(220, 220, 220, 1)"
              }
              secondaryColor={
                darkMode ? "rgba(45, 48, 45,0.8)" : "rgba(200, 200, 200, 1)"
              }
            />
            <ContentLoader
              containerStyles={{
                paddingHorizontal: 0,
                marginTop: 0,
                marginBottom: 0,
              }}
              active={true}
              pHeight={[20]}
              title={false}
              pRows={2}
              pWidth={["100%"]}
              paragraphStyles={{ marginBottom: 20, marginTop: 0 }}
              animationDuration={400}
              primaryColor={
                darkMode ? "rgba(45, 48, 45,1)" : "rgba(220, 220, 220, 1)"
              }
              secondaryColor={
                darkMode ? "rgba(45, 48, 45,0.8)" : "rgba(200, 200, 200, 1)"
              }
            />
            <ContentLoader
              containerStyles={{
                paddingHorizontal: 0,
                marginTop: 0,
                marginBottom: 0,
              }}
              active={true}
              pHeight={[32]}
              title={false}
              pRows={2}
              pWidth={["100%"]}
              paragraphStyles={{ marginBottom: 0, marginTop: 0 }}
              animationDuration={400}
              primaryColor={
                darkMode ? "rgba(45, 48, 45,1)" : "rgba(220, 220, 220, 1)"
              }
              secondaryColor={
                darkMode ? "rgba(45, 48, 45,0.8)" : "rgba(200, 200, 200, 1)"
              }
            />
          </View>
        </View>
        <View style={[Flex.row]}>
          <View style={{ flex: 0.4 }}>
            <ContentLoader
              containerStyles={{
                paddingHorizontal: 0,
                marginTop: 0,
                marginBottom: 0,
              }}
              active={true}
              pHeight={[200]}
              title={false}
              pRows={1}
              pWidth={["100%"]}
              paragraphStyles={{ marginBottom: 40, marginTop: 0 }}
              animationDuration={400}
              primaryColor={
                darkMode ? "rgba(45, 48, 45,1)" : "rgba(220, 220, 220, 1)"
              }
              secondaryColor={
                darkMode ? "rgba(45, 48, 45,0.8)" : "rgba(200, 200, 200, 1)"
              }
            />
          </View>
          <View style={[Margin.ml_2, { flex: 0.6 }]}>
            <ContentLoader
              containerStyles={{
                paddingHorizontal: 0,
                marginTop: 0,
                marginBottom: 0,
              }}
              active={true}
              pHeight={[50]}
              title={false}
              pRows={1}
              pWidth={["100%"]}
              paragraphStyles={{ marginBottom: 20, marginTop: 0 }}
              animationDuration={400}
              primaryColor={
                darkMode ? "rgba(45, 48, 45,1)" : "rgba(220, 220, 220, 1)"
              }
              secondaryColor={
                darkMode ? "rgba(45, 48, 45,0.8)" : "rgba(200, 200, 200, 1)"
              }
            />
            <ContentLoader
              containerStyles={{
                paddingHorizontal: 0,
                marginTop: 0,
                marginBottom: 0,
              }}
              active={true}
              pHeight={[20]}
              title={false}
              pRows={2}
              pWidth={["100%"]}
              paragraphStyles={{ marginBottom: 20, marginTop: 0 }}
              animationDuration={400}
              primaryColor={
                darkMode ? "rgba(45, 48, 45,1)" : "rgba(220, 220, 220, 1)"
              }
              secondaryColor={
                darkMode ? "rgba(45, 48, 45,0.8)" : "rgba(200, 200, 200, 1)"
              }
            />
            <ContentLoader
              containerStyles={{
                paddingHorizontal: 0,
                marginTop: 0,
                marginBottom: 0,
              }}
              active={true}
              pHeight={[32]}
              title={false}
              pRows={2}
              pWidth={["100%"]}
              paragraphStyles={{ marginBottom: 0, marginTop: 0 }}
              animationDuration={400}
              primaryColor={
                darkMode ? "rgba(45, 48, 45,1)" : "rgba(220, 220, 220, 1)"
              }
              secondaryColor={
                darkMode ? "rgba(45, 48, 45,0.8)" : "rgba(200, 200, 200, 1)"
              }
            />
          </View>
        </View>
      </View>
    );
  };

  renderWebPage = () => {
    return <>{this.renderPageContent()}</>;
  };

  renderAppPage = () => {
    return (
      <ScrollView style={{ flex: 1 }}>{this.renderPageContent()}</ScrollView>
    );
  };

  renderHomeCover() {
    let { whatsTrendingContent } = this.state;
    let darkMode = helpers.isDarkMode(this.props?.app?.DarkMode);
    return (
      <>
        {/* <TouchableOpacity onPress={()=> this.handlepress() }>
                    <Text>
                        Send Notification
                    </Text>
                </TouchableOpacity>  */}
        <HomeCover
          data={whatsTrendingContent}
          viewArticle={(catSlug, slug, postData) =>
            this.viewArticle(catSlug, slug, postData)
          }
          viewAuthor={(slug) => this.viewAuthor(slug)}
          viewCategory={(slug) => this.viewCategory(slug)}
          darkMode={darkMode}
        />
      </>
    );
  }

  renderLatestStory() {
    let { latestPremiumStories, featuredStory } = this.state;
    let darkMode = helpers.isDarkMode(this.props?.app?.DarkMode);
    return (
      <>
        <View
          style={[
            helpers.isDesktop() ? Flex.row : Flex.column,
            Flex.justifyEnd,
          ]}
        >
          <View style={{ width: helpers.isDesktop() ? "65%" : "100%" }}>
            <HomeLatestStory
              data={latestPremiumStories.slice(0, 8)}
              viewArticle={(catSlug, slug, postData) =>
                this.viewArticle(catSlug, slug, postData)
              }
              viewAuthor={(slug) => this.viewAuthor(slug)}
              viewCategory={(slug) => this.viewCategory(slug)}
              viewAllArticles={() => this.viewAllArticles()}
              trackStoryClick={(title, data, position) => {
                /*this.trackStoryClick('click_latest_story', title, data, position)*/
              }}
              darkMode={darkMode}
            />
          </View>
          {this.renderYesterdayStory(darkMode)}
        </View>
      </>
    );
  }

  renderFeaturedStory() {
    let { featuredStory } = this.state;
    let darkMode = helpers.isDarkMode(this.props?.app?.DarkMode);
    return (
      <HomeFeaturedStory
        data={featuredStory}
        viewArticle={(catSlug, slug, postData) =>
          this.viewArticle(catSlug, slug, postData)
        }
        viewAuthor={(slug) => this.viewAuthor(slug)}
        viewCategory={(slug) => this.viewCategory(slug)}
        hideDate={true}
        darkMode={darkMode}
      />
    );
  }

  renderStoriesForYou() {
    let { storiesForYou } = this.state;
    let darkMode = helpers.isDarkMode(this.props?.app?.DarkMode);
    return (
      <HomeStoriesForYou
        data={storiesForYou}
        viewArticle={(catSlug, slug, postData) =>
          this.viewArticle(catSlug, slug, postData)
        }
        viewAuthor={(slug) => this.viewAuthor(slug)}
        viewCategory={(slug) => this.viewCategory(slug)}
        darkMode={darkMode}
      />
    );
  }

  renderPopularCategory() {
    let darkMode = helpers.isDarkMode(this.props?.app?.DarkMode);
    let sectionTitle = {
      title: "Popular Themes",
    };
    return (
      <HomePopularCategories
        data={sectionTitle}
        trackThemeClick={(theme) => this.trackThemeClick(theme)}
        getTagClick={(slug) => this.navigateToTag(slug)}
        darkMode={darkMode}
      />
    );
  }

  renderRecentNewsletters() {
    let { archivedStories } = this.state;
    let darkMode = helpers.isDarkMode(this.props?.app?.DarkMode);

    return (
      <HomeRecentNewsletters
        data={archivedStories}
        viewArticle={(catSlug, slug, postData) =>
          this.viewArticle(catSlug, slug, postData)
        }
        viewAuthor={(slug) => this.viewAuthor(slug)}
        viewCategory={(slug) => this.viewCategory(slug)}
        navigateWeb={(slug) => this.props.navigateToScreen(slug)}
        navigateApp={(slug, params) =>
          this.props.navigation.navigate(slug, params)
        }
        trackSignUp={(email, position) => {
          this.trackSignUp(email, position);
        }}
        trackStoryClick={(title, data, position) => {
          this.trackStoryClick(
            "click_starter_collection",
            title,
            data,
            position
          );
        }}
        darkMode={darkMode}
      />
    );
  }

  renderNewsletterCategory(token) {
    let darkMode = helpers.isDarkMode(this.props?.app?.DarkMode);
    let sectionTitle = {
      title: "Explore Newsletters on",
    };
    if (token === "token") {
      return (
        <HomeNewsletterCategories
          loggedOut={false}
          data={sectionTitle}
          trackThemeClick={(theme) => this.trackThemeClick(theme)}
          getTagClick={(slug) => this.navigateToTag(slug)}
          darkMode={darkMode}
        />
      );
    } else {
      return (
        <HomeNewsletterCategories
          loggedOut={true}
          data={sectionTitle}
          trackThemeClick={(theme) => this.trackThemeClick(theme)}
          getTagClick={(slug) => this.navigateToTag(slug)}
          darkMode={darkMode}
        />
      );
    }
  }

  renderPremiumStories() {
    let { premiumStories, credits } = this.state;
    let darkMode = helpers.isDarkMode(this.props?.app?.DarkMode);
    return (
      <HomePremiumStory
        data={premiumStories}
        viewArticle={(catSlug, slug, postData) =>
          this.viewArticle(catSlug, slug, postData)
        }
        viewAuthor={(slug) => this.viewAuthor(slug)}
        viewCategory={(slug) => this.viewCategory(slug)}
        credits={credits}
        trackStoryClick={(title, data, position) => {
          this.trackStoryClick("click_premium_story", title, data, position);
        }}
        darkMode={darkMode}
        viewAllStories={() => this.viewAllStories()}
      />
    );
  }
  renderYesterdayStory(darkMode) {
    return (
      <View
        style={{
          width: helpers.isDesktop() ? "30%" : "100%",
          marginTop: helpers.isDesktop() ? "-5px" : "15%",
        }}
      >
        <HomeYesterdayStory
          token={this.state.token}
          navigateWeb={(slug) => this.props.navigateToScreen(slug)}
          navigateApp={(slug, params) =>
            this.props.navigation.navigate(slug, params)
          }
          darkMode={darkMode}
        />
      </View>
    );
  }
  renderuserStarterCollection() {
    let { userStarterCollection, credits, token } = this.state;
    let darkMode = helpers.isDarkMode(this.props?.app?.DarkMode);
    return (
      <>
        <View style={[helpers.isDesktop() ? Flex.row : Flex.column]}>
          <View
            style={{
              width: helpers.isDesktop() ? "70%" : "100%",
            }}
          >
            <HomeStarterCollection
              data={userStarterCollection}
              token={token}
              viewArticle={(catSlug, slug, postData) =>
                this.viewArticle(catSlug, slug, postData)
              }
              viewAuthor={(slug) => this.viewAuthor(slug)}
              viewCategory={(slug) => this.viewCategory(slug)}
              credits={credits}
              trackStoryClick={(title, data, position) => {
                this.trackStoryClick(
                  "click_starter_story",
                  title,
                  data,
                  position
                );
              }}
              darkMode={darkMode}
              viewStarterCollection={() => {
                this.viewStarterCollection();
              }}
            />
          </View>
          {this.renderYesterdayStory(darkMode)}
        </View>
      </>
    );
  }

  CB__HostedPage__CollectNow = () => /*
      Opens CB hosted page URL(redirection) to collect view/pay unpaid invoices
  */
    {
      const { token } = this.state;
      if (!token) {
        console.log(
          "unpaidInvoiceBand:CB__HostedPage__CollectNow: not authenticated user"
        );
        return false
      }
      this.setState({ unpaidInvoiceLoader: true });
      ChargebeeController.activatedController().then(cb_handle => {
        cb_handle.hosted_page.collect_now()
      })
    };

  renderUnpaidInvoiceBand() {
    let { token, unpaidInvoiceLoader } = this.state;
    let darkMode = helpers.isDarkMode(this.props?.app?.DarkMode);
    return (
      <GeneralNotificationBand
        buttonLoader={unpaidInvoiceLoader}
        ctaHandle={() => {
          this.CB__HostedPage__CollectNow();
        }}
        token={token}
        notificationText="You will soon lose access. Keep reading the best of independent, financial journalism."
        redirectionPath="#accounts"
        ctaText="RENEW"
        backgroundColor="#E5707E"
        darkMode={darkMode}
      />
    );
  }

  renderSubscriptionExpiryBand() {
    let { token } = this.state;
    let darkMode = helpers.isDarkMode(this.props?.app?.DarkMode);
    return (
      <GeneralNotificationBand
        token={token}
        notificationText="Your subscription with The Morning Context has ended."
        redirectionPath="/pricing"
        ctaText="RENEW SUBSCRIPTION"
        backgroundColor="#E5707E"
        darkMode={darkMode}
      />
    );
  }

  advanceRenewalChecks(){
    let canRenew = this.canAdvanceRenew()
    if(!canRenew){
      return;
    }
    ChargebeeController.activatedController().then(handle => {
      handle.API.subscription.payment_source({
          subscription: {
              id: handle.activeSubscription.subscription_id
          }
      }).then(res => {
          this.setState({
            userPaymentInfo: res
          })
      }).catch(err => {
          console.log('chargebee: API:payment_source:Error: ', err)
      })

    })

  }

  canAdvanceRenew(){
    let { subscriptionDetails, token } = this.state;

      if(!token){
        return false
      }

      return helpers.canAdvanceRenew(subscriptionDetails)
  }

  hasPaymentMandate() {
    let { subscriptionDetails, userPaymentInfo } = this.state;
    if(!userPaymentInfo){
      return false
    }
    const hasMandates = (userPaymentInfo.mandates? true: false)
    if(!hasMandates){
      return false
    }
    const mandateList = userPaymentInfo.mandates
    return mandateList.some((manadateObject) => {
      if(manadateObject.subscription_id === subscriptionDetails.subscription_id){
        return true
      }
      return false
    })

  }

  isSubscriptionUnderDunning() {
    let { subscriptionDetails } = this.state;
    if(subscriptionDetails.dunning_status == 'in_progress'){
      return true
    }
    return false
  }

  paymentBandChain() {
    let { subscriptionDetails, userPaymentInfo } = this.state;

      try{
        if(subscriptionDetails.is_cancelled){
          return this.showCancellationRemovalBand()
        }else{
          const cancellationRemovalEventKey = `scheduled-cancellation-removed:${subscriptionDetails.subscription_id}`
          localStorage.removeItem(cancellationRemovalEventKey)
        }
  
        if(!this.canAdvanceRenew()){
          return;
        }
  
        if(this.hasPaymentMandate()){
          return;
        }
        if(userPaymentInfo){
          // return this.showMandateBand(subscriptionDetails, this.state.userPaymentInfo)
          return this.showAdvanceRenewalBand()
        }
      }catch(err){
        console.log('home:paymentBandChain:Error: ',err)
      }

      return;
  }

  showCancellationRemovalBand(){
    let { subscriptionDetails, token, canShowBandLoader } = this.state;
    let darkMode = helpers.isDarkMode(this.props?.app?.DarkMode);

    if(!subscriptionDetails?.end_date){
      return;
    }
    const cancellationRemovalEventKey = `scheduled-cancellation-removed:${subscriptionDetails.subscription_id}`
    const cancellationRemovalEventObject = localStorage.getItem(cancellationRemovalEventKey)
    if(cancellationRemovalEventObject){
      try{
        const cancellationData = JSON.parse(cancellationRemovalEventObject)
        if(cancellationData.expiresAt){
          let cancellationRemovalEventExpiry = new Date(cancellationData.expiresAt)
          if(new Date() <= cancellationRemovalEventExpiry){
            return;
          }
        }
      }
      catch(err){
        console.log('removeCancellation:eventObject:Error: ', err)
      }
    }
    const removeCancellation = () => {
      this.setState({canShowBandLoader: true})
      ChargebeeController.activatedController().then(handle => {
        handle.API.subscription.remove_scheduled_cancellation({
            subscription: {
                id: handle.activeSubscription.subscription_id
            }
        }).then(res => {
            try{
              const currentDate = new Date()
              const eventData = {
                value: true,
                expiresAt: currentDate.setMinutes(currentDate.getMinutes() + 2) 
              }
              localStorage.setItem(cancellationRemovalEventKey, JSON.stringify(eventData))
            }catch(err){
              console.log('removeCancellation:Error: ', err)
            }
            window.location.reload()
        }).catch(err => {
            console.log('chargebee: API:remove_scheduled_cancellation:Error: ', err)
        })
      })
    }

    return (
      <GeneralNotificationBand
        buttonLoader={canShowBandLoader}
        token={token}
        notificationText={`Your subscription has been cancelled.`}
        redirectionPath={`/pricing`}
        ctaText="CONTINUE READING"
        ctaHandle={removeCancellation}
        backgroundColor="#E5707E"
        darkMode={darkMode}
      />
    );
  }

  showAdvanceRenewalBand(){
    return this.renderSubscriptionRenewalBand()
  }
  showMandateBand(subscriptionDetails, paymentInfo) {
    return this.renderMandateRequestBand()
  }
  renderMandateRequestBand() {
    let { subscriptionDetails, token } = this.state;
    let darkMode = helpers.isDarkMode(this.props?.app?.DarkMode);

    if(!subscriptionDetails){
      return;
    }
    const openPortal = () => {
      let forwardOptions = {
        sectionType: "sub_details",
        params: {
          subscriptionId: subscriptionDetails.subscription_id
        }
      }
      ChargebeeController.activatedController().then(cb_handle => {
          if(!cb_handle){
              throw new Error("CB Handle not inited")
          }
          cb_handle.portal.open(forwardOptions)
      })
    }

    return (
      <GeneralNotificationBand
        token={token}
        notificationText={`Please enable mandate`}
        redirectionPath={`/pricing`}
        ctaText="RENEW"
        ctaHandle={openPortal}
        backgroundColor="#E5707E"
        darkMode={darkMode}
      />
    );
  }

  renderSubscriptionRenewalBand() {
    let { subscriptionDetails, token } = this.state;
    let darkMode = helpers.isDarkMode(this.props?.app?.DarkMode);

    if(!subscriptionDetails?.end_date){
      return;
    }
    const openAdvanceRenewal = () => {
      ChargebeeController.activatedController().then(cb_handle => {
          cb_handle.hosted_page.checkout_existing({
            terms_to_charge: 1,
            invoice_immediately: true,
          }, {}, false)
      })
    }

    return (
      <GeneralNotificationBand
        token={token}
        notificationText={`Keep reading the best of independent, financial journalism.`}
        redirectionPath={`/pricing?advance-renew=true`}
        ctaText="RENEW"
        ctaHandle={openAdvanceRenewal}
        backgroundColor="#E5707E"
        darkMode={darkMode}
      />
    );
  }


  renderCreditExpiryBand() {
    let { userStarterCollection, credits, token } = this.state;
    let darkMode = helpers.isDarkMode(this.props?.app?.DarkMode);
    return (
      <CreditExpiryBand
        token={token}
        viewArticle={(catSlug, slug, postData) =>
          this.viewArticle(catSlug, slug, postData)
        }
        viewAuthor={(slug) => this.viewAuthor(slug)}
        viewCategory={(slug) => this.viewCategory(slug)}
        credits={credits}
        trackStoryClick={(title, data, position) => {
          this.trackStoryClick("click_starter_story", title, data, position);
        }}
        darkMode={darkMode}
        viewStarterCollection={() => {
          this.viewStarterCollection();
        }}
      />
    );
  }

  renderPaidExpiryBand() {
    console.log("renderPaidExpiryBand");
    let { subscriptionDetails, credits, token } = this.state;
    let darkMode = helpers.isDarkMode(this.props?.app?.DarkMode);
    return (
      <PaidExpiryBand
        subscription={subscriptionDetails}
        token={token}
        viewArticle={(catSlug, slug, postData) =>
          this.viewArticle(catSlug, slug, postData)
        }
        viewAuthor={(slug) => this.viewAuthor(slug)}
        viewCategory={(slug) => this.viewCategory(slug)}
        credits={credits}
        trackStoryClick={(title, data, position) => {
          this.trackStoryClick("click_starter_story", title, data, position);
        }}
        darkMode={darkMode}
        viewStarterCollection={() => {
          this.viewStarterCollection();
        }}
      />
    );
  }

  renderuserNewsletterCollection() {
    let { homeContent, credits } = this.state;
    let darkMode = helpers.isDarkMode(this.props?.app?.DarkMode);
    return (
      <HomeNewsletterSection
        newsLetters={homeContent.newsletters}
        viewArticle={(catSlug, slug, postData) =>
          this.viewArticle(catSlug, slug, postData)
        }
        viewAuthor={(slug) => this.viewAuthor(slug)}
        viewCategory={(slug) => this.viewCategory(slug)}
        credits={credits}
        trackStoryClick={(title, data, position) => {
          this.trackStoryClick("click_starter_story", title, data, position);
        }}
        darkMode={darkMode}
        viewStarterCollection={() => {
          this.viewStarterCollection();
        }}
      />
    );
  }

  renderExlusiveContent() {
    let { exclusiveContent, homeContent, freeUser } = this.state;
    let darkMode = helpers.isDarkMode(this.props?.app?.DarkMode);
    let data = homeContent.newsletters;
    let data1 = [];
    let data2 = [];
    let data3 = [];
    let data4 = [];
    let newdata;
    Array.from(data)
      .slice(0, 1)
      .map((item, index) => {
        data1.push(item);
      });
    Array.from(data)
      .slice(2, 3)
      .map((item, index) => {
        data2.push(item);
      });
    Array.from(data)
      .slice(3, 4)
      .map((item, index) => {
        data3.push(item);
      });
    Array.from(data)
      .slice(6, 7)
      .map((item, index) => {
        data4.push(item);
        newdata = data1.concat(data2).concat(data3).concat(data4);
      });

    let text = "Enjoying The Morning Context?";
    if (freeUser) {
      return (
        <HomeExclusiveContent
          data={exclusiveContent}
          enjoyText={text}
          newsletterData={newdata}
          viewArticle={(catSlug, slug, postData) =>
            this.viewArticle(catSlug, slug, postData)
          }
          viewAuthor={(slug) => this.viewAuthor(slug)}
          viewCategory={(slug) => this.viewCategory(slug)}
          trackStoryClick={(title, data, position) => {
            /*this.trackStoryClick('click_exclusive_content', title, data, position)*/
          }}
          darkMode={darkMode}
        />
      );
    } else {
      return (
        <HomeExclusiveContent
          data={exclusiveContent}
          newsletterData={newdata}
          viewArticle={(catSlug, slug, postData) =>
            this.viewArticle(catSlug, slug, postData)
          }
          viewAuthor={(slug) => this.viewAuthor(slug)}
          viewCategory={(slug) => this.viewCategory(slug)}
          trackStoryClick={(title, data, position) => {
            /*this.trackStoryClick('click_exclusive_content', title, data, position)*/
          }}
          darkMode={darkMode}
        />
      );
    }
  }

  renderArchivedStories() {
    let { archivedStories } = this.state;
    let darkMode = helpers.isDarkMode(this.props?.app?.DarkMode);
    return (
      <HomeArchievedContent
        data={archivedStories}
        viewArticle={(catSlug, slug, postData) =>
          this.viewArticle(catSlug, slug, postData)
        }
        viewAuthor={(slug) => this.viewAuthor(slug)}
        viewCategory={(slug) => this.viewCategory(slug)}
        navigateWeb={(slug) => this.props.navigateToScreen(slug)}
        navigateApp={(slug, params) =>
          this.props.navigation.navigate(slug, params)
        }
        trackSignUp={(email, position) => {
          this.trackSignUp(email, position);
        }}
        trackStoryClick={(title, data, position) => {
          this.trackStoryClick(
            "click_starter_collection",
            title,
            data,
            position
          );
        }}
        darkMode={darkMode}
      />
    );
  }

  renderYesterdaySection() {
    let darkMode = helpers.isDarkMode(this.props?.app?.DarkMode);
    let { storyData } = this.state;
    return (
      <View
        style={[
          !helpers.isDesktop() && Flex.row,
          !helpers.isDesktop() && Flex.alignStart,
          {
            backgroundColor: helpers.isDesktop ? "#ffffff" : "#F3F5FF",
            height: helpers.isDesktop() ? "auto" : 950,
            width: "100%",
            overflow: "hidden",
            position: "relative",
            backgroundImage: helpers.isDesktop() ? `url(${bg2})` : "none",
            marginBottom: helpers.isDesktop() ? 30 : "auto",
          },
        ]}
      >
        {/* {helpers.isDesktop() && (
          <CustomImage
            source={bg2}
            require={true}
            style={[
              helpers.isWeb()
                ? {
                    maxWidth: helpers.isDesktop() ? "100%" : "auto",
                    height: "auto",
                    width: 1920,
                  }
                : { width: "100%" },
            ]}
            altText={"The Morning Context"}
          />
        )} */}

        <View
          style={[
            Flex.row,
            helpers.isDesktop() && Flex.alignCenter,
            Flex.justfiyCenter,
            {
              position: "relative",
              top: helpers.isDesktop() ? 63 : 0,
              left: 0,
              width: "100%",
              height: "100%",
            },
          ]}
        >
          <View style={[{ position: "relative", width: "100%" }]}>
            {helpers.isDesktop() && (
              <View style={[{ position: "relative", width: "100%" }]}>
                <Text
                  style={[
                    {
                      fontSize: helpers.isDesktop() ? 72 : 40,
                      lineHeight: helpers.isDesktop() ? 80 : 44,
                      fontFamily: FontFamily.abrilFatface,
                      color: "#FFF",
                    },
                    { marginBottom: 29, textAlign: "center" },
                    darkMode && { color: "rgba(255, 255, 255, 0.89)" },
                  ]}
                >
                  Introducing{" "}
                  <Text
                    style={{ borderBottomWidth: 3, borderBottomColor: "#FFF" }}
                  >
                    Yesterday
                  </Text>
                </Text>
                <Text
                  style={[
                    {
                      alignSelf: "center",
                      fontSize: helpers.isDesktop() ? 24 : 16,
                      lineHeight: helpers.isDesktop() ? 36 : 24,
                      fontFamily: FontFamily.regular,
                      color: "#FFF",
                    },
                    {
                      textAlign: "center",
                      width: helpers.isDesktop() ? 800 : "80%",
                      margin: "auto",
                      marginBottom: helpers.isDesktop() ? 60 : 10,
                    },
                    darkMode && { color: "rgba(255, 255, 255, 0.89)" },
                  ]}
                >
                  Everything that’s happened around the world in the news.
                  Clutter-free with a quick, to-the-point perspective. We land
                  in your inbox every weekday at 8 am IST.
                </Text>
                <View style={{ padding: 0 }}>
                  <ButtonGradient
                    title={"GET STARTED FOR FREE"}
                    rootStyle={{
                      btnWrapper: [button.primaryGradient, { width: "100%" }],
                      btnText: [
                        button.primaryGradientText,
                        { fontSize: 16, fontWeight: "600" },
                      ],
                    }}
                    onClick={() =>
                      this.props.navigateToScreen(`/sign-up?redirect=/&`)
                    }
                    darkMode={darkMode}
                  />
                </View>
              </View>
            )}

            <View style={[Flex.row, Flex.justfiyCenter]}>
              <View
                style={[
                  {
                    width: helpers.isDesktop() ? "80%" : "100%",
                  },
                  !helpers.isDesktop() && {
                    backgroundColor: "#F3F5FF",
                  },
                ]}
              >
                {!helpers.isDesktop() && (
                  <View style={{ alignItems: "center" }}>
                    <View style={{ width: 220, marginTop: 28 }}>
                      {/* <CustomImage
                        resizeMode={"contain"}
                        source={YesterdayLogo1}
                        require={true}
                        style={[
                          helpers.isWeb()
                            ? { width: "100%", height: "auto" }
                            : { width: "100%", height: 250 },
                        ]}
                        altText={"Have Only 5 Minutes"}
                      /> */}
                      <view
                        style={{
                          clipPath:
                            "polygon(0 0, 100% 0, 100% 100%, 50% 83%, 0 100%)",
                          background:
                            "linear-gradient(17.24deg, #55C79A 9.08%, #907CFF 58.44%, #FC876D 103.84%)",
                          width: helpers.isDesktop() ? 15 : 8.46,
                          height: helpers.isDesktop() ? 31 : 17.71,
                          position: "absolute",
                          left: 0,
                          top: "13%",
                        }}
                      ></view>

                      <Text
                        style={{
                          fontSize: helpers.isDesktop() ? 46 : 26,
                          fontWeight: "700",
                          color: "#051462",
                          paddingLeft: helpers.isDesktop() ? 29.38 : 16.56,
                          lineHeight: helpers.isDesktop() ? 46 : 26,
                          fontFamily: "Matteo-bold",
                          letterSpacing: "0.2em",
                        }}
                      >
                        YESTERDAY
                      </Text>
                    </View>
                    <Text
                      style={[
                        {
                          fontSize: helpers.isDesktop() ? 60 : 27,
                          lineHeight: helpers.isDesktop() ? 72 : 35,
                          fontFamily: FontFamily.abrilFatface,
                          color: "#051462",
                          marginTop: 14,
                        },
                        { paddingBottom: 3, textAlign: "center" },
                        darkMode && { color: "rgba(255, 255, 255, 0.89)" },
                      ]}
                    >
                      Have only 5 mins? That’s{"\n"}enough to stay updated{" "}
                    </Text>

                    {helpers.isDesktop() && (
                      <Text
                        style={[
                          {
                            fontSize: helpers.isDesktop() ? 24 : 16,
                            lineHeight: helpers.isDesktop() ? 36 : 23,
                            marginTop: 8,
                            paddingLeft: 8,
                            paddingRight: 8,
                            fontFamily: FontFamily.regular,
                            color: "#051462",
                          },
                          { paddingBottom: 3, textAlign: "center" },
                          darkMode && { color: "rgba(255, 255, 255, 0.89)" },
                        ]}
                      >
                        {" "}
                        We’ve bookmarked some of the most important{"\n"}news
                        from yesterday to make sure you don’t miss{"\n"}out on
                        the latest happenings. We drop in your inbox every
                        weekday at 8 am IST.
                      </Text>
                    )}
                    {!helpers.isDesktop() && (
                      <Text
                        style={[
                          {
                            fontSize: helpers.isDesktop() ? 24 : 16,
                            lineHeight: helpers.isDesktop() ? 36 : 23,
                            marginTop: 8,
                            paddingLeft: 8,
                            paddingRight: 8,
                            fontFamily: FontFamily.regular,
                            color: "#051462",
                          },
                          { paddingBottom: 3, textAlign: "center" },
                          darkMode && { color: "rgba(255, 255, 255, 0.89)" },
                        ]}
                      >
                        {" "}
                        We’ve bookmarked some of the most important news from
                        yesterday to make sure you don’t miss out on the latest
                        happenings. We drop in your inbox every weekday at 8 am
                        IST.
                      </Text>
                    )}
                  </View>
                )}
                <View
                  style={[
                    {
                      padding: helpers.isDesktop() ? 40 : 10,
                      paddingBottom: 0,
                    },
                    darkMode && { backgroundColor: Colors.darkPurple },
                  ]}
                >
                  <View
                    style={[
                      helpers.isDesktop() && {
                        backgroundColor: "#ffffff",
                        padding: helpers.isDesktop() ? 20 : 10,
                        maxWidth: helpers.isDesktop() ? "70%" : "100%",
                        width: "100%",
                        margin: "auto",
                      },
                    ]}
                  >
                    {helpers.isDesktop() && (
                      <Text
                        style={[
                          {
                            fontSize: helpers.isDesktop() ? 36 : 22,
                            lineHeight: helpers.isDesktop() ? 39.6 : 32.56,
                            fontFamily: FontFamily.bold,
                            color: "#051462",
                            fontWeight: "600",
                          },
                          {
                            paddingBottom: helpers.isDesktop() ? 30 : 10,
                            paddingTop: 10,
                            textAlign: "left",
                          },
                          darkMode && { color: "rgba(255, 255, 255, 0.89)" },
                        ]}
                      >
                        {" "}
                        {moment(storyData?.published_date).format(
                          "DD MMMM, YYYY"
                        )}
                      </Text>
                    )}

                    <ScrollView
                      scrollEnabled={helpers.isDesktop() ? false : true}
                      showsHorizontalScrollIndicator={false}
                      horizontal={helpers.isDesktop() ? false : true}
                      style={{
                        flexDirection: helpers.isDesktop() ? "column" : "row",
                      }}
                    >
                      {storyData &&
                        storyData.posts &&
                        storyData.posts.slice(0, 3).map((item, index) => {
                          return (
                            <View
                              style={[
                                { backgroundColor: "#ffffff" },
                                { marginBottom: 14 },
                                darkMode && {
                                  backgroundColor: Colors.darkPurple,
                                },
                                !helpers.isDesktop() && {
                                  maxWidth: 325,
                                  padding: 15,
                                  paddingTop: 22,
                                  paddingRight: 8,
                                  borderLeftWidth: helpers.isDesktop() ? 0 : 3,
                                  // borderColor: "#ECB731",
                                  borderColor: renderBorderColor(
                                    item?.category[0]
                                  ),
                                  margin: 9.5,
                                },
                              ]}
                            >
                              <View
                                style={[
                                  {
                                    width: helpers.isDesktop()
                                      ? "100%"
                                      : "100%",
                                    marginBottom: 15,
                                  },
                                ]}
                              >
                                {item.category.map((value, index) => {
                                  return (
                                    <View>
                                      <Text
                                        style={[
                                          {
                                            color: renderBorderColor(value),
                                            fontFamily: FontFamily.bold,
                                            textTransform: "uppercase",
                                            fontSize: 15,
                                            lineHeight: 16,
                                            backgroundImage: `url(${categoryImage(
                                              value
                                            )})`,
                                            backgroundRepeat: "no-repeat",
                                          },
                                          paddingCategory(value),
                                        ]}
                                      >
                                        {value}
                                      </Text>
                                    </View>
                                    // <CustomImage
                                    //   // source={healthcare}
                                    //   source={categoryImage(value)}
                                    //   require={true}
                                    //   style={[
                                    //     helpers.isWeb()
                                    //       ? {
                                    //         width: helpers.isDesktop()
                                    //           ? 116
                                    //           : 96,
                                    //         height: "auto",
                                    //       }
                                    //       : {
                                    //         width: helpers.isDesktop()
                                    //           ? 116
                                    //           : 96,
                                    //         height: 30,
                                    //       },
                                    //   ]}
                                    //   altText={"The Morning Context"}
                                    // />
                                  );
                                })}
                              </View>

                              <View
                                style={[
                                  {
                                    marginBottom: helpers.isDesktop() ? 30 : 0,
                                    borderLeftWidth: helpers.isDesktop()
                                      ? 4
                                      : 0,
                                    // borderColor: "#ECB731",
                                    borderColor: renderBorderColor(
                                      item?.category[0]
                                    ),
                                    paddingLeft: 10,
                                  },
                                ]}
                              >
                                <TouchableOpacity
                                  onPress={() =>
                                    this.props.navigateToScreen(
                                      `/yesterday/${storyData.slug}`
                                    )
                                  }
                                >
                                  <Text
                                    style={[
                                      {
                                        fontSize: helpers.isDesktop() ? 24 : 18,
                                        lineHeight: helpers.isDesktop()
                                          ? 34
                                          : 26,
                                        fontFamily: FontFamily.bold,
                                        color: "#051462",
                                      },
                                      { paddingBottom: 3, textAlign: "left" },
                                      darkMode && {
                                        color: "rgba(255, 255, 255, 0.89)",
                                      },
                                    ]}
                                  >
                                    {item.title}
                                  </Text>
                                  <Text
                                    style={[
                                      {
                                        fontSize: helpers.isDesktop() ? 18 : 16,
                                        lineHeight: helpers.isDesktop()
                                          ? 26
                                          : 23,
                                        fontFamily: FontFamily.regular,
                                        color: "#051462",
                                      },
                                      { paddingBottom: 3, textAlign: "left" },
                                      darkMode && {
                                        color: "rgba(255, 255, 255, 0.89)",
                                      },
                                    ]}
                                  >
                                    {item.content}...
                                    {/* <PostContent
                                    data={truncate(item.content, 10, {
                                      byWords: true,
                                    })}
                                    darkMode={darkMode}
                                    openLink={(link) =>
                                      this.openSocialMedia(link)
                                    }
                                  /> */}
                                    {/* {truncate(item.content, 2, { byWords: true })} */}
                                  </Text>
                                </TouchableOpacity>
                              </View>
                              {!helpers.isDesktop() && (
                                <TouchableOpacity
                                  onPress={() =>
                                    this.props.navigateToScreen(
                                      `/yesterday/${storyData.slug}`
                                    )
                                  }
                                  style={[
                                    Flex.row,
                                    Flex.alignCenter,
                                    { padding: 8, paddingVertical: 16 },
                                  ]}
                                >
                                  <Text
                                    style={[
                                      {
                                        fontSize: helpers.isDesktop() ? 18 : 15,
                                        lineHeight: helpers.isDesktop()
                                          ? 26
                                          : 22,
                                        fontFamily: FontFamily.bold,
                                        color: "#907CFF",
                                      },
                                      {
                                        textAlign: "left",
                                        paddingRight: 10,
                                      },
                                      darkMode && {
                                        color: "rgba(255, 255, 255, 0.89)",
                                      },
                                    ]}
                                  >
                                    LEARN MORE
                                  </Text>
                                  <View>
                                    <CustomImage
                                      source={rightArrow}
                                      require={true}
                                      resizeMode={"contain"}
                                      style={[{ width: 14.8, height: 18 }]}
                                      altText={"The Morning Context"}
                                    />
                                  </View>
                                </TouchableOpacity>
                              )}
                            </View>
                          );
                        })}
                      {/* <View
                        style={[
                          { backgroundColor: "#ffffff" },
                          { marginBottom: 30 },
                          darkMode && { backgroundColor: Colors.darkPurple },
                          !helpers.isDesktop() && {
                            maxWidth: 325,
                            padding: 15,
                            paddingTop: 22,
                            paddingRight: 8,
                            borderLeftWidth: helpers.isDesktop() ? 0 : 3,
                            borderColor: "#ECB731",
                            margin: 9.5,
                          },
                        ]}
                      >
                        <View
                          style={[
                            {
                              width: helpers.isDesktop() ? 116 : 96,
                              marginBottom: 15,
                            },
                          ]}
                        >
                          <CustomImage
                            source={healthcare}
                            require={true}
                            style={[
                              helpers.isWeb()
                                ? {
                                    width: helpers.isDesktop() ? 116 : 96,
                                    height: "auto",
                                  }
                                : {
                                    width: helpers.isDesktop() ? 116 : 96,
                                    height: 30,
                                  },
                            ]}
                            altText={"The Morning Context"}
                          />
                        </View>
                        <View
                          style={[
                            {
                              marginBottom: helpers.isDesktop() ? 30 : 0,
                              borderLeftWidth: helpers.isDesktop() ? 8 : 0,
                              borderColor: "#ECB731",
                              paddingLeft: 10,
                            },
                          ]}
                        >
                          <Text
                            style={[
                              {
                                fontSize: helpers.isDesktop() ? 24 : 18,
                                lineHeight: helpers.isDesktop() ? 34 : 26,
                                fontFamily: FontFamily.bold,
                                color: "#051462",
                              },
                              { paddingBottom: 3, textAlign: "left" },
                              darkMode && {
                                color: "rgba(255, 255, 255, 0.89)",
                              },
                            ]}
                          >
                            Mumbai saw its first Delta COVID-19 variant death; a
                            fully vaccinated woman died
                          </Text>
                          <Text
                            style={[
                              {
                                fontSize: helpers.isDesktop() ? 18 : 16,
                                lineHeight: helpers.isDesktop() ? 36 : 23,
                                fontFamily: FontFamily.regular,
                                color: "#051462",
                              },
                              { paddingBottom: 3, textAlign: "left" },
                              darkMode && {
                                color: "rgba(255, 255, 255, 0.89)",
                              },
                            ]}
                          >
                            The 63-year-old woman was infected with the Delta
                            Plus variant of the virus, succumbing to it on July
                            27, said Brihanmumbai Municipal Corporation (BMC)
                            officials. The authorities came to know only on...
                          </Text>
                        </View>
                        {!helpers.isDesktop() && (
                          <TouchableOpacity
                            onPress={() =>
                              this.props.navigation.navigate(
                                "/yesterday/story_name"
                              )
                            }
                            style={[
                              Flex.row,
                              Flex.alignCenter,
                              { padding: 8, paddingVertical: 16 },
                            ]}
                          >
                            <Text
                              style={[
                                {
                                  fontSize: helpers.isDesktop() ? 18 : 15,
                                  lineHeight: helpers.isDesktop() ? 26 : 22,
                                  fontFamily: FontFamily.bold,
                                  color: "#907CFF",
                                },
                                {
                                  textAlign: "left",
                                  paddingRight: 10,
                                },
                                darkMode && {
                                  color: "rgba(255, 255, 255, 0.89)",
                                },
                              ]}
                            >
                              LEARN MORE
                            </Text>
                            <View>
                              <CustomImage
                                source={rightArrow}
                                require={true}
                                resizeMode={"contain"}
                                style={[{ width: 14.8, height: 18 }]}
                                altText={"The Morning Context"}
                              />
                            </View>
                          </TouchableOpacity>
                        )}
                      </View>
                      <View
                        style={[
                          { backgroundColor: "#ffffff" },
                          { marginBottom: 30 },
                          darkMode && { backgroundColor: Colors.darkPurple },
                          !helpers.isDesktop() && {
                            maxWidth: 325,
                            padding: 15,
                            paddingTop: 22,
                            paddingRight: 8,
                            borderLeftWidth: helpers.isDesktop() ? 0 : 3,
                            borderColor: "#ECB731",
                            margin: 9.5,
                          },
                        ]}
                      >
                        <View
                          style={[
                            {
                              width: helpers.isDesktop() ? 116 : 96,
                              marginBottom: 15,
                            },
                          ]}
                        >
                          <CustomImage
                            source={healthcare}
                            require={true}
                            style={[
                              helpers.isWeb()
                                ? {
                                    width: helpers.isDesktop() ? 116 : 96,
                                    height: "auto",
                                  }
                                : {
                                    width: helpers.isDesktop() ? 116 : 96,
                                    height: 30,
                                  },
                            ]}
                            altText={"The Morning Context"}
                          />
                        </View>
                        <View
                          style={[
                            {
                              marginBottom: helpers.isDesktop() ? 30 : 0,
                              borderLeftWidth: helpers.isDesktop() ? 8 : 0,
                              borderColor: "#ECB731",
                              paddingLeft: 10,
                            },
                          ]}
                        >
                          <Text
                            style={[
                              {
                                fontSize: helpers.isDesktop() ? 24 : 18,
                                lineHeight: helpers.isDesktop() ? 34 : 26,
                                fontFamily: FontFamily.bold,
                                color: "#051462",
                              },
                              { paddingBottom: 3, textAlign: "left" },
                              darkMode && {
                                color: "rgba(255, 255, 255, 0.89)",
                              },
                            ]}
                          >
                            Mumbai saw its first Delta COVID-19 variant death; a
                            fully vaccinated woman died
                          </Text>
                          <Text
                            style={[
                              {
                                fontSize: helpers.isDesktop() ? 18 : 16,
                                lineHeight: helpers.isDesktop() ? 36 : 23,
                                fontFamily: FontFamily.regular,
                                color: "#051462",
                              },
                              { paddingBottom: 3, textAlign: "left" },
                              darkMode && {
                                color: "rgba(255, 255, 255, 0.89)",
                              },
                            ]}
                          >
                            The 63-year-old woman was infected with the Delta
                            Plus variant of the virus, succumbing to it on July
                            27, said Brihanmumbai Municipal Corporation (BMC)
                            officials. The authorities came to know only on...
                          </Text>
                        </View>
                        {!helpers.isDesktop() && (
                          <TouchableOpacity
                            onPress={() =>
                              this.props.navigation.navigate(
                                "/yesterday/story_name"
                              )
                            }
                            style={[
                              Flex.row,
                              Flex.alignCenter,
                              { padding: 8, paddingVertical: 16 },
                            ]}
                          >
                            <Text
                              style={[
                                {
                                  fontSize: helpers.isDesktop() ? 18 : 15,
                                  lineHeight: helpers.isDesktop() ? 26 : 22,
                                  fontFamily: FontFamily.bold,
                                  color: "#907CFF",
                                },
                                {
                                  textAlign: "left",
                                  paddingRight: 10,
                                },
                                darkMode && {
                                  color: "rgba(255, 255, 255, 0.89)",
                                },
                              ]}
                            >
                              LEARN MORE
                            </Text>
                            <View>
                              <CustomImage
                                source={rightArrow}
                                require={true}
                                resizeMode={"contain"}
                                style={[{ width: 14.8, height: 18 }]}
                                altText={"The Morning Context"}
                              />
                            </View>
                          </TouchableOpacity>
                        )}
                      </View> */}
                    </ScrollView>

                    <View style={[Flex.row, Flex.justfiyCenter]}>
                      <View
                        style={[
                          { padding: 20, width: 200 },
                          !helpers.isDesktop() && {
                            marginBottom: 40,
                            width: "95%",
                          },
                        ]}
                      >
                        {!helpers.isDesktop() && (
                          <ButtonGradient
                            title={"GET STARTED FOR FREE"}
                            rootStyle={{
                              btnWrapper: [
                                button.primaryGradient,
                                {
                                  width: "100%",
                                  marginVertical: 20,
                                  borderRadius: 0,
                                },
                              ],
                              btnText: [
                                button.primaryGradientText,
                                { fontSize: 16, fontWeight: "600" },
                              ],
                            }}
                            onClick={() =>
                              this.props.navigateToScreen(
                                `/sign-up?redirect=/&`
                              )
                            }
                            darkMode={darkMode}
                          />
                        )}
                        {helpers.isDesktop() ? (
                          <ButtonGradient
                            title={"READ MORE"}
                            rootStyle={{
                              btnWrapper: [
                                button.primaryGradient,
                                { width: "100%" },
                              ],
                              btnText: [
                                button.primaryGradientText,
                                { fontSize: 16, fontWeight: "600" },
                              ],
                            }}
                            onClick={() =>
                              this.props.navigateToScreen(`/yesterday`)
                            }
                            darkMode={darkMode}
                          />
                        ) : (
                          <Button
                            title={"LEARN MORE"}
                            rootStyle={{
                              btnWrapper: [
                                darkMode
                                  ? button.primaryOutlineSmallDark
                                  : button.primaryOutlineSmall,
                                { height: 36 },
                              ],
                              btnText: [
                                darkMode
                                  ? button.primaryOutlineTextSmallDark
                                  : button.primaryOutlineTextSmall,
                                {
                                  fontWeight: "600",
                                  paddingHorizontal: 15,
                                  fontSize: 16,
                                },
                              ],
                            }}
                            onClick={() => {
                              this.props.navigateToScreen(`/yesterday`);
                            }}
                          />
                        )}
                      </View>
                    </View>
                  </View>
                </View>
              </View>
            </View>
          </View>
        </View>
      </View>
    );
  }

  renderHomeTrendingStories() {
    let { freeUser, latestPremiumStories, token, readingList, featuredStory } =
      this.state;
    let darkMode = helpers.isDarkMode(this.props?.app?.DarkMode);
    return (
      <>
        {/* <View style={[helpers.isDesktop() && { flexDirection: 'row', flexWrap: 'wrap' }, Helpers.conatinerWeb, helpers.isDesktop() && Helpers.conatinerWebFull, {
                    backgroundColor: '#F3F5FF', marginTop: 30
                }]}> */}
        {/* <View style={{
                        width: helpers.isDesktop() ? '69%' : '100%',
                    }
                    }> */}
        {/* {trendingStoriesContent.map((category) => { */}
        {/* return ( */}
        <HomeTrendingStories
          data={featuredStory}
          freeUser={freeUser}
          viewArticle={(catSlug, slug, postData) =>
            this.viewArticle(catSlug, slug, postData)
          }
          viewAuthor={(slug) => this.viewAuthor(slug)}
          viewCategory={(slug) => this.viewCategory(slug)}
          viewCompany={(slug) => this.viewCompany(slug)}
          trackStoryClick={(title, data, position) => {
            /*this.trackStoryClick('click_top_stories', title, data, position)*/
          }}
          darkMode={darkMode}
          viewAllInCategory={(slug) =>
            this.props.navigation.navigate("categories", {
              archiveType: "category",
              archiveSlug: slug,
            })
          }
        />
        {/* ) */}
        {/* })} */}
        {/* </View> */}
        {/* {readingList && <HomeReadingList data={readingList} viewArticle={(catSlug, slug, postData) => this.viewArticle(catSlug, slug, postData)} viewAuthor={(slug) => this.viewAuthor(slug)} viewCategory={(slug) => this.viewCategory(slug)} navigateApp={(slug, params) => this.props.navigation.navigate(slug, params)} darkMode={darkMode} />} */}
        {/* </View> */}
      </>
    );
  }

  renderCarousal() {
    let { homeContent, token } = this.state;
    let darkMode = helpers.isDarkMode(this.props?.app?.DarkMode);
    let data = homeContent.newsletters;
    let data1 = [];
    let data2 = [];
    let data3 = [];
    let data4 = [];
    Array.from(data)
      .slice(0, 2)
      .map((item, index) => {
        data1.push(item);
      });
    Array.from(data)
      .slice(2, 4)
      .map((item, index) => {
        data2.push(item);
      });
    Array.from(data)
      .slice(4, 6)
      .map((item, index) => {
        data3.push(item);
      });
    Array.from(data)
      .slice(6, 8)
      .map((item, index) => {
        data4.push(item);
      });

    return (
      <PremiumSlider
        token={token}
        categorySlug={"newsletter"}
        token={this.state.token}
        data={homeContent.newsletters}
        data1={data1}
        data2={data2}
        data3={data3}
        data4={data4}
        viewArticle={(catSlug, slug, postData) =>
          this.viewArticle(catSlug, slug, postData)
        }
        viewAuthor={(slug) => this.viewAuthor(slug)}
        viewCategory={(slug) => this.viewCategory(slug)}
        getNewsletterClick={(slug) => this.navigateToNewsletter(slug)}
        home={true}
        darkMode={darkMode}
      />
    );
  }

  renderWriters() {
    let { homeContent } = this.state;
    let darkMode = helpers.isDarkMode(this.props?.app?.DarkMode);
    let data = this.state.writers;
    let data1 = [];
    let data2 = [];
    let data3 = [];
    let data4 = [],
      data5 = [],
      data6 = [];
    Array.from(data)
      .slice(0, 3)
      .map((item, index) => {
        data1.push(item);
      });
    Array.from(data)
      .slice(3, 6)
      .map((item, index) => {
        data2.push(item);
      });
    Array.from(data)
      .slice(6, 9)
      .map((item, index) => {
        data3.push(item);
      });
    Array.from(data)
      .slice(9, 12)
      .map((item, index) => {
        data4.push(item);
      });
    Array.from(data)
      .slice(12, 15)
      .map((item, index) => {
        data5.push(item);
      });
    Array.from(data)
      .slice(15, 18)
      .map((item, index) => {
        data6.push(item);
      });
    return (
      <WritersSlider
        categorySlug={"writers"}
        data={data}
        data1={data1}
        data2={data2}
        data3={data3}
        data4={data4}
        data5={data5}
        data6={data6}
        viewArticle={(catSlug, slug, postData) =>
          this.viewArticle(catSlug, slug, postData)
        }
        viewAuthor={(slug) => this.viewAuthor(slug)}
        viewCategory={(slug) => this.viewCategory(slug)}
        getNewsletterClick={(slug) => this.viewAuthor(slug)}
        home={true}
        darkMode={darkMode}
      />
    );
  }

  renderNewsLetters() {
    let { homeContent } = this.state;
    let darkMode = helpers.isDarkMode(this.props?.app?.DarkMode);
    return (
      <HomeNewsLetters
        categorySlug={"newsletter"}
        data={homeContent.newsletters}
        viewArticle={(catSlug, slug, postData) =>
          this.viewArticle(catSlug, slug, postData)
        }
        viewAuthor={(slug) => this.viewAuthor(slug)}
        viewCategory={(slug) => this.viewCategory(slug)}
        getNewsletterClick={(slug) => this.navigateToNewsletter(slug)}
        home={true}
        darkMode={darkMode}
      />
    );
  }

  renderReadersQuotes() {
    let { homeContent } = this.state;
    let darkMode = helpers.isDarkMode(this.props?.app?.DarkMode);
    return (
      <HomeReadersQuote
        categorySlug={"newsletter"}
        data={homeContent.readers_quotes}
        viewArticle={(catSlug, slug, postData) =>
          this.viewArticle(catSlug, slug, postData)
        }
        viewAuthor={(slug) => this.viewAuthor(slug)}
        viewCategory={(slug) => this.viewCategory(slug)}
        darkMode={darkMode}
      />
    );
  }

  renderSubscriptionSection() {
    const { navigation } = this.props;
    const { freeUser } = this.state;
    let darkMode = helpers.isDarkMode(this.props?.app?.DarkMode);
    if (freeUser) {
      return (
        <HomeChooseSubscription
          freeUser={true}
          navigateWeb={(slug) => this.props.navigateToScreen(slug)}
          key={this.state.subscriptionRefreshKey}
          navigateScreenHistory={(pushProp) => this.navigateScreen(pushProp)}
          showSubscriptionPlan={(subscribtionId, subscribtion, country) => {
            this.refs.header.showSubscriptionPlan(
              subscribtionId,
              subscribtion,
              country
            );
            this.trackSubscriptionClick(subscribtion);
          }}
          navigation={navigation}
          darkMode={darkMode}
        />
      );
    } else {
      return (
        <HomeChooseSubscription
          freeUser={false}
          navigateWeb={(slug) => this.props.navigateToScreen(slug)}
          key={this.state.subscriptionRefreshKey}
          navigateScreenHistory={(pushProp) => this.navigateScreen(pushProp)}
          showSubscriptionPlan={(subscribtionId, subscribtion, country) => {
            this.refs.header.showSubscriptionPlan(
              subscribtionId,
              subscribtion,
              country
            );
            this.trackSubscriptionClick(subscribtion);
          }}
          navigation={navigation}
          darkMode={darkMode}
        />
      );
    }
  }

  renderOurMissionSection() {
    let darkMode = helpers.isDarkMode(this.props?.app?.DarkMode);
    return <HomeOurMission darkMode={darkMode} />;
  }

  renderHomeBannerSection() {
    let darkMode = helpers.isDarkMode(this.props?.app?.DarkMode);
    return (
      <HomeBanner
        navigateWeb={(slug) => this.props.navigateToScreen(slug)}
        navigateApp={(slug, params) =>
          this.props.navigation.navigate(slug, params)
        }
        trackSignUp={(email, position) => {
          this.trackSignUp(email, position);
        }}
        darkMode={darkMode}
      />
    );
  }

  renderWhyTMCSection() {
    let darkMode = helpers.isDarkMode(this.props?.app?.DarkMode);
    return <HomeWhyTMCSection home={true} darkMode={darkMode} />;
  }

  renderJoinYoutube() {
    let darkMode = helpers.isDarkMode(this.props?.app?.DarkMode);
    let text;
    if (this.state.token) {
      text = "Catch up on all the past events";
      return <JoinYoutube catchUp={text} home={true} darkMode={darkMode} />;
    } else {
      return <JoinYoutube catchUp={false} home={true} darkMode={darkMode} />;
    }
  }

  renderAppAvailablePosterSection() {
    let darkMode = helpers.isDarkMode(this.props?.app?.DarkMode);
    return (
      <AppAvailablePoster
        navigateWeb={(slug) => this.props.navigateToScreen(slug)}
        navigateApp={(slug, params) =>
          this.props.navigation.navigate(slug, params)
        }
        trackSignUp={(email, position) => {
          this.trackSignUp(email, position);
        }}
        darkMode={darkMode}
      />
    );
  }

  renderFreeTrialSection() {
    return (
      <HomeFreeTrial
        navigateWeb={(slug) => this.props.navigateToScreen(slug)}
        navigateApp={(slug, params) =>
          this.props.navigation.navigate(slug, params)
        }
      />
    );
  }

  renderDarkModeSwitch() {
    let darkMode = helpers.isDarkMode(this.props?.app?.DarkMode);
    return (
      <View
        style={[
          Helpers.conatinerWeb,
          helpers.isDesktop() && Helpers.conatinerWebFull,
          { zIndex: 1 },
          { marginBottom: helpers.isDesktop() ? 50 : 25 },
        ]}
      >
        <DarkModeSwitch darkMode={darkMode} />
      </View>
    );
  }

  trackSignUp = (email, position) => {
    Mixpanel.track("click_signup", { email: email });
    // Mixpanel.track('click_signup', { email: email, position: position });
  };

  trackStoryClick = (event_name, title, data, position) => {
    Mixpanel.track(event_name, {
      title: title,
      author: data.author[0].name,
      date: data.published_date,
      category: data.category.name,
      position: position,
    });
  };

  trackSubscriptionClick = (subscribtion) => {
    try {
      Mixpanel.track("click_subscription", { plan: subscribtion.name });
    } catch (error) {
      console.log("mix panel =>", error);
    }
  };

  trackThemeClick = () => {
    // try {
    //     if (helpers.isWeb()) {
    //         Mixpanel.track('click_popular_themes', { theme: theme });
    //     }
    // }
    // catch (error) {
    //     console.log('mix panel error =>', error);
    // }
  };

  navigateScreen = (pushProp) => {
    if (helpers.isWeb()) {
      this.props.history.push(pushProp);
    } else {
      if (pushProp == "/") {
        this.getData();
      } else {
        this.props.navigation.navigate(pushProp);
      }
    }
  };

  goToHome = () => {
    if (helpers.isWeb()) {
      this.props.navigateScreen("/");
    } else {
      this.getData();
      this.refs.header.getUserInfo();
    }
  };

  render() {
    const {
      pageLoader,
      userInfoFetched,
      trendingStoriesContent,
      showErrorModal,
      footerData,
      subscriptionRefreshKey,
      token,
    } = this.state;
    let darkMode = helpers.isDarkMode(this.props?.app?.DarkMode);
    const { freeUser } = this.state;
    const webView = helpers.isWeb();
    let redirectSlugs = {
      web: "/",
      native: { redirect: "/", verifyRedirect: "/" },
    };

    if (freeUser) {
      return (
        <View
          style={[
            webView && { paddingTop: helpers.isDesktop() ? 54 : 56 },
            appStyles.appBg,
            Flex.fill,
            darkMode && appStyles.appBgDark,
          ]}
        >
          <Seo
            data={seoObj["home"]}
            page="/"
            url={
              process.browser
                ? window.location.origin + window.location.pathname
                : ""
            }
          />
          <AppHeader
            ref="header"
            history={this.props.history}
            searchQuery={this.props.searchQuery}
            locationHash={this.props.locationHash}
            navigateWeb={(slug) => this.props.navigateToScreen(slug)}
            navigateApp={(slug, params) =>
              this.props.navigation.navigate(slug, params)
            }
            redirectSlugs={redirectSlugs}
            refreshPage={() =>
              this.setState({ subscriptionRefreshKey: !subscriptionRefreshKey })
            }
            setCredits={(credits) => this.setState({ credits: credits })}
            navigateToSubscriptionScreen
            darkMode={darkMode}
            showFullHeader={true}
          />
          {!showErrorModal && (
            <>
              {pageLoader || !userInfoFetched || !trendingStoriesContent
                ? this.showPageLoader()
                : webView
                  ? this.renderWebPage()
                  : this.renderAppPage()}
            </>
          )}

          <AppFooter
            freeUser={true}
            navigateWeb={(slug) => this.props.navigateToScreen(slug)}
            navigateApp={(slug, params) =>
              this.props.navigation.navigate(slug, params)
            }
            footerData={footerData}
            Breadcrumbs={Breadcrumbs}
          />
          {showErrorModal && (
            <ErrorModal
              goToHome={() => this.goToHome()}
              tryAgain={() => (webView ? this.getData() : this.goToHome())}
              show={showErrorModal}
            />
          )}
        </View>
      );
    } else {
      return (
        <View
          style={[
            webView && { paddingTop: helpers.isDesktop() ? 54 : 56 },
            appStyles.appBg,
            Flex.fill,
            darkMode && appStyles.appBgDark,
          ]}
        >
          <Seo
            data={seoObj["home"]}
            page="/"
            url={
              process.browser
                ? window.location.origin + window.location.pathname
                : ""
            }
          />
          <AppHeader
            ref="header"
            history={this.props.history}
            searchQuery={this.props.searchQuery}
            locationHash={this.props.locationHash}
            navigateWeb={(slug) => this.props.navigateToScreen(slug)}
            navigateApp={(slug, params) =>
              this.props.navigation.navigate(slug, params)
            }
            redirectSlugs={redirectSlugs}
            refreshPage={() =>
              this.setState({ subscriptionRefreshKey: !subscriptionRefreshKey })
            }
            setCredits={(credits) => this.setState({ credits: credits })}
            navigateToSubscriptionScreen
            darkMode={darkMode}
            showFullHeader={true}
          />
          {!showErrorModal && (
            <>
              {pageLoader || !userInfoFetched || !trendingStoriesContent
                ? this.showPageLoader()
                : webView
                  ? this.renderWebPage()
                  : this.renderAppPage()}
            </>
          )}
          <AppFooter
            freeUser={false}
            navigateWeb={(slug) => this.props.navigateToScreen(slug)}
            navigateApp={(slug, params) =>
              this.props.navigation.navigate(slug, params)
            }
            footerData={footerData}
            Breadcrumbs={Breadcrumbs}
          />
          {showErrorModal && (
            <ErrorModal
              goToHome={() => this.goToHome()}
              tryAgain={() => (webView ? this.getData() : this.goToHome())}
              show={showErrorModal}
            />
          )}
        </View>
      );
    }
  }
}

const mapStateToProps = (state) => {
  const { app, user } = state;
  return { app, user };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ removeUserToken, storeFcmToken }, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AuthenticationWrapper(Home));

let Breadcrumbs = [
  {
    name: "Home",
    link: "/",
  },
];
